<template>
  <div>
    <v-row
      v-if="loading"
      class="justify-center"
    >
      <v-col cols="12">
        <div class="loading-grid">
          <div
            v-for="n in 54"
            :key="n"
            class="skeleton-card"
          ></div>
        </div>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col
        v-for="(room, index) in rooms"
        :key="index"
      >
        <div
          class="box_room"
          :class="checkoutToday(room)"
          @click="showRoom(room)"
        >
          <div class="text-center label_room_status">
            {{ status(room.status) }}
          </div>
          <div class="text-center label_room">
            {{ room.description }}
          </div>
          <div class="text-center label_category">
            {{ room.category.description }}
          </div>
          <!-- <div class="text-center label_room_time">{{room.status_time_remaining}}</div> -->
        </div>
      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogRoom"
      fullscreen
      persistent
      no-click-animation
    >
      <v-card>
        <BarTitleDialog
          :title="descriptionRoom"
          @close="dialogRoom = false"
        />
        <dialog-busy
          v-if="inArray(editedItem.status, ['periodo', 'ocupado'])"
          :key="`busy-${editedItem.id || 'none'}`"
          v-model="dialogRoom"
          :room="editedItem"
          @updategrid="updateGrid()"
          @close="dialogRoom = false"
        />
        <dialog-status-room
          v-if="inArray(editedItem.status, ['bloqueado', 'disponivel', 'diaria', 'conferencia', 'encerramento', 'limpeza', 'manutencao', 'pernoite', 'stand-by', 'sujo', 'reservado'],)"
          :key="`status-${editedItem.id || 'none'}`"
          :room="editedItem"
          @close="dialogRoom = false"
          @updategrid="updateGrid()"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import DialogBusy from './_components/DialogBusy.vue'
import DialogStatusRoom from './_components/DialogStatusRoom.vue'

export default {
  components: {
    DialogBusy,
    BarTitleDialog,
    DialogStatusRoom,
  },
  data: () => ({
    dialogRoom: false,
    descriptionRoom: '',
    editedItemLoading: false,
    socket: null,
    socketHandlers: {},
    config: {},
    headers: [
      {
        text: 'Produto',
        align: 'start',
        value: 'name',
      },
      {
        text: 'QTDE',
        align: 'right',
        value: 'name',
      },
      {
        text: 'Un. (R$)',
        align: 'right',
        value: 'name',
      },
      {
        text: 'Total',
        align: 'right',
        value: 'name',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],

    statusItems: [
      {
        value: 'sujo',
        text: 'Sujo',
      },
      {
        value: 'bloqueado',
        text: 'Bloqueado',
      },
      {
        value: 'diaria',
        text: 'Diaria',
      },
      {
        value: 'disponivel',
        text: 'Disponível',
      },
      {
        value: 'conferencia',
        text: 'Conferência',
      },
      {
        value: 'encerramento',
        text: 'Encerramento',
      },
      {
        value: 'limpeza',
        text: 'Limpeza',
      },
      {
        value: 'manutencao',
        text: 'Manutenção',
      },
      {
        value: 'ocupado',
        text: 'Ocupado',
      },
      {
        value: 'periodo',
        text: 'Período',
      },
      {
        value: 'pernoite',
        text: 'Pernoite',
      },
      {
        value: 'reservado',
        text: 'Reservado',
      },
      {
        value: 'stand-by',
        text: 'Stand-by',
      },
    ],
    rooms: [],
    editedItem: {},
    indexItem: null,
    icons: {},
    loading: false,
  }),
  computed: {},
  created() {
    this.inicialize()
    this.loadTariffs()
    this.loadRoomCategories()
    this.setupSocketListeners()
  },
  beforeDestroy() {
    this.teardownSocketListeners()
  },
  methods: {
    ...mapActions('manager_room', ['getAllRoom', 'update', 'updatedRoomGrid']),
    ...mapActions('select', ['loadTariffs', 'loadRoomCategories']),

    setupSocketListeners() {
      if (!this.$socket) {
        console.warn('Socket global não foi configurado')

        return
      }

      this.socket = this.$socket
      this.socketHandlers = {
        connect: () => console.log('Socket conectado!'),
        disconnect: reason => console.log('Socket desconectado!', reason),
        roomUpdated: payload => {
          if (payload?.event === 'room-updated') {
            this.updateRoomGrid(payload.data)
          }
        },
      }

      this.socket.on('connect', this.socketHandlers.connect)
      this.socket.on('disconnect', this.socketHandlers.disconnect)
      this.socket.on('update-grid', this.socketHandlers.roomUpdated)
    },
    teardownSocketListeners() {
      if (!this.socket || !this.socketHandlers) {
        return
      }

      this.socket.off('connect', this.socketHandlers.connect)
      this.socket.off('disconnect', this.socketHandlers.disconnect)
      this.socket.off('update-grid', this.socketHandlers.roomUpdated)
    },
    inicialize() {
      this.loading = true
      this.getAllRoom()
        .then(response => {
          this.rooms = response.data

          // se tiver parametro room_id na rota ja abri a tela do quarto
          // if(this.$route.params.room_id){
          //   const room =  this.rooms.find((room)=>{
          //     return room.id == this.$route.params.room_id
          //   })
          //   this.showRoom(room)
          // }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateGrid() {
      this.inicialize()
    },
    updateRoomGrid(data) {
      this.updatedRoomGrid(data)
        .then(response => {
          const updatedRoom = response.data
          const index = this.rooms.findIndex(room => room.id === updatedRoom.id)
          if (index !== -1) {
            this.rooms.splice(index, 1, updatedRoom)
          }
          if (this.editedItem.id === updatedRoom.id) {
            this.editedItem = { ...updatedRoom }
          }
        })
    },
    showRoom(room) {
      this.indexItem = this.rooms.indexOf(room)
      this.editedItem = {
        ...room,
      }
      this.dialogRoom = true
      this.descriptionRoom = room.description.toUpperCase()
    },
    save(room) {
      this.editedItemLoading = true
      this.update(this.editedItem)
        .then(response => {
          Object.assign(this.rooms[this.indexItem], response.data)
          this.dialogRoom = false
        })
        .finally(() => {
          this.editedItemLoading = false
        })
    },
    status(status) {
      switch (status) {
        case 'sujo':
          return 'Sujo'
        case 'bloqueado':
          return 'Bloqueado'
        case 'diaria':
          return 'Diária'
        case 'disponivel':
          return 'Disponível'
        case 'conferencia':
          return 'Conferência'
        case 'encerramento':
          return 'Encerramento'
        case 'limpeza':
          return 'Limpeza'
        case 'manutencao':
          return 'Manutenção'
        case 'ocupado':
          return 'Ocupado'
        case 'periodo':
          return 'Período'
        case 'pernoite':
          return 'Pernoite'
        case 'reservado':
          return 'Reservado'
        case 'stand-by':
          return 'Stand-by'
      }
    },
    inArray(item, arr) {
      const result = arr.find(i => i == item)

      if (result) {
        return true
      }

      return false
    },
    checkoutToday(room) {
      if (room.status == 'ocupado') {
        const [checkout, hour] = room.prev_checkout.split(' ')
        const now = new Date()
        now.setHours(now.getHours() - 3)
        if (new Date(checkout) <= now) {
          return 'ocupado_checkout'
        }
      }

      return room.status
    },

  },
  watch: {},
}
</script>

<style scoped>
.label_room_status,
.label_room,
.label_category {
  color: #fff;
  text-shadow: 0 1px 3px rgb(0 0 0 / 85%);
}

.label_category {
  font-size: 13px;
  box-sizing: border-box;
}

.label_room {
  font-size: 20px;
  box-sizing: border-box;
  margin-top: 65px;
  padding-top: 5px;
  font-weight: bold;
}

.loading-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-auto-rows: 140px;
  gap: 16px;
  justify-items: stretch;
}

.skeleton-card {
  background: linear-gradient(90deg, #f5f5f5 25%, #e6e6e6 37%, #f5f5f5 63%);
  background-size: 400% 100%;
  border-radius: 10px;
  animation: shimmer 1.4s ease infinite;
  min-height: 140px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.label_room_status {
  font-size: 15px;
  box-sizing: border-box;
  padding-top: 4px;
}

.label_room_time {
  font-size: 12px;
  color: white;
}

.box_room {
  background-size: 100%;
  width: 150px;
  height: 150px;
  cursor: pointer;
}

.bloqueado {
  background-image: url('../../assets/images/rooms/bloqueado.png');
}

.diaria {
  background-image: url('../../assets/images/rooms/diaria.png');
}

.disponivel {
  background-image: url('../../assets/images/rooms/disponivel.png');
}

.conferencia {
  background-image: url('../../assets/images/rooms/conferencia.png');
}

.encerramento {
  background-image: url('../../assets/images/rooms/encerramento.png');
}

.limpeza {
  background-image: url('../../assets/images/rooms/limpeza.png');
}

.manutencao {
  background-image: url('../../assets/images/rooms/manutencao.png');
}

.ocupado {
  background-image: url('../../assets/images/rooms/ocupado.png');
}

.ocupado_checkout {
  background-image: url('../../assets/images/rooms/ocupado_checkout2.png');
}

.periodo {
  background-image: url('../../assets/images/rooms/periodo.png');
}

.pernoite {
  background-image: url('../../assets/images/rooms/pernoite.png');
}

.reservado {
  background-image: url('../../assets/images/rooms/reservado2.png');
}

.stand-by {
  background-image: url('../../assets/images/rooms/stand-by.png');
}

.sujo {
  background-image: url('../../assets/images/rooms/sujo.png');
}
</style>
